import React, { useContext, useEffect, useRef, memo } from 'react';
import PropTypes from 'prop-types';
import Message from './Message';
import SimpleBarReact from 'simplebar-react';
import { ChatContext } from 'context/Context';

const ChatContentBody = ({ thread }) => {
  const messagesEndRef = useRef();
  const messageNodes = useRef({});
  const handledSearch = useRef(null);
  const { scrollToBottom, setScrollToBottom, searchQuery } = useContext(ChatContext);
  const content = thread?.messages;

  useEffect(() => {
    const hit = messageNodes.current[searchQuery.id] || null;
    const target = hit || (scrollToBottom ? messagesEndRef.current : null);

    if (!target) return;
    if (hit) handledSearch.current = searchQuery;

    const timeout = setTimeout(() => {
      target.scrollIntoView({ behavior: 'auto', block: hit ? 'start' : 'end' });
      if (scrollToBottom) setScrollToBottom(false);
    }, 500);

    return () => clearTimeout(timeout);
  }, [scrollToBottom, searchQuery]);

  return (
    <div className="chat-content-body" style={{ display: 'inherit' }}>
      <SimpleBarReact style={{ height: '100%' }}>
        <div className="chat-content-scroll-area">
          {content?.map(({ answer, question, id, isPositive }) => (
            <div
              key={id}
              ref={node => {
                if (node) messageNodes.current[id] = node;
                else delete messageNodes.current[id];
              }}
            >
              {question && <Message message={question} type='q' id={id} />}
              {answer && <Message message={answer} type='a' id={id} rating={isPositive} />}
            </div>
          ))}
        </div>
        <div ref={messagesEndRef} style={{ float: "left", clear: "both" }} />
      </SimpleBarReact>
    </div>
  );
};

ChatContentBody.propTypes = {
  thread: PropTypes.object.isRequired
};

export default memo(ChatContentBody);
